.element-settings-tree {
  &:not([data-level="0"]):not([data-level="1"]) {
    padding-left: 1.5em;
    border-left: .05em solid;

  }

  padding: .5rem 0;
}
